import React from 'react';
import { FaPhone, FaEnvelope } from 'react-icons/fa';
import Container from './Container';

const TopBar = () => {
  return (
    <div className="top-bar">
      <Container>

        <div className="top-bar-container">
          <a href="tel:855-428-3537" className="top-bar-item">
            <FaPhone />
            <span>855-428-3537</span>
          </a>
          <a href="mailto:info@eldr-us.com" className="top-bar-item">
            <FaEnvelope />
            <span>info@eldr-us.com</span>
          </a>
        </div>
      </Container>
    </div>
  );
};

export default TopBar;
